import { createSlice } from '@reduxjs/toolkit';
import { getUserDetails, removeUserDetails, setUserDetails } from 'utils/storage.utils';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        loading: false,
        error: null,
        token: null,
        permissions: {}
    },
    reducers: {
        hydrateFromStorage(state) {
            const { token, user, permissions } = getUserDetails();
            state.token = token || null;
            state.user = user || null;
            state.permissions = permissions;
            state.loading = false;
            state.error = null;
            state.isLoggedIn = !!token && !!user;
        },
        loginStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        loginSuccess: (state, action) => {
            const { token, permissions, ...user } = action.payload;
            state.user = user;
            state.token = token;
            state.loading = false;
            state.error = null;
            state.isLoggedIn = true;
            state.permissions = permissions;
            setUserDetails({ token, user, permissions });
        },
        loginFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.isLoggedIn = false;
        },
        registerStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        registerSuccess: (state, action) => {
            const { token, user } = action.payload;
            state.user = user;
            state.token = token;
            state.loading = false;
            state.error = null;
            setUserDetails({ token, user });
        },
        registerFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        logoutStart: (state) => {
            state.loading = true;
        },
        logoutSuccess: (state) => {
            state.loading = false;
            state.user = null;
            state.token = null;
            state.error = null;
            state.isLoggedIn = false;
            removeUserDetails();
        },
        logoutFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        refreshStart: (state) => {
            state.loading = true;
        },
        refreshSuccess: (state, action) => {
            state.loading = false;
            state.token = action.payload.token;
        },
        refreshFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    loginStart,
    loginSuccess,
    loginFail,
    registerStart,
    registerSuccess,
    registerFail,
    logoutStart,
    logoutSuccess,
    logoutFail,
    refreshStart,
    refreshSuccess,
    refreshFail,
    hydrateFromStorage,
} = authSlice.actions;

export default authSlice.reducer;